import { render, staticRenderFns } from "./ShowAlianzas.vue?vue&type=template&id=7733940e"
import script from "./ShowAlianzas.vue?vue&type=script&lang=js"
export * from "./ShowAlianzas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7733940e')) {
      api.createRecord('7733940e', component.options)
    } else {
      api.reload('7733940e', component.options)
    }
    module.hot.accept("./ShowAlianzas.vue?vue&type=template&id=7733940e", function () {
      api.rerender('7733940e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/alianzas/components/ShowAlianzas.vue"
export default component.exports